import { Avatar, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import * as ROUTES from '../../../../router/Routes';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allMatriculasAction,
  deleteMatriculasAction,
  setActivoMatriculasAction,
} from '../MatriculasAction';
import { PARAMS_MATRICULAS } from '../MatriculasReducer';

const ListadoMatriculas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();
  let history = useHistory();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const matriculasStore = Redux.useSelector((state) => state.matriculas);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      const payload = {
        ...matriculasStore.params,
        idEntidad: entidadesStore.activo.id,
      };

      dispatch({ type: PARAMS_MATRICULAS, payload });
      if (matriculasStore.all && matriculasStore.all.length === 0) {
        await allMatriculasAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    matriculasStore.all.forEach((el) => {
      const seccion = el.secciones.find((sec) => !sec.aprobado)?.seccion;
      rowsData.push({
        ...el,
        imagen: el.estudiante.usuario.perfil.avatar,
        dni: `${el.estudiante.usuario.perfil.tipoDni}-${el.estudiante.usuario.perfil.dni}`,
        nombre: `${el.estudiante.usuario.perfil.papellido} ${
          el.estudiante.usuario.perfil.sapellido ?? ''
        } ${el.estudiante.usuario.perfil.pnombre} ${
          el.estudiante.usuario.perfil.snombre ?? ''
        }`,
        seccion: seccion ? `${seccion.nombre}-${seccion.turno}` : 'Sin sección',
        nivelAcademico: seccion?.nivelAcademico.nivelAcademico.nombre ?? '--',
        carrera: seccion?.carrera?.carrera?.nombre ?? '--',
        estatus: el.estatus.nombre,
      });
    });
    setRows(rowsData);
  }, [matriculasStore.all]);

  const _handleEditClick = async (id) => {
    const data = matriculasStore.all.find((el) => el.id === id);
    await setActivoMatriculasAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteMatriculasAction(
      { dispatch, notify },
      matriculasStore.activo.id,
      matriculasStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.imagen.name,
      label: CONST.imagen.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Avatar
              alt={value}
              sx={{ width: 50, height: 50 }}
              src={getFilesArchivos(value)}
            />
          );
        },
      },
    },
    {
      name: CONST.nroRegistro.name,
      label: CONST.nroRegistro.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.dni.name,
      label: CONST.dni.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.nombre.name,
      label: 'Estudiante',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.seccion.name,
      label: CONST.seccion.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.nivelAcademico.name,
      label: CONST.nivelAcademico.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.carrera.name,
      label: CONST.carrera.label,
      options: {
        filter: true,
        sort: true,
      },
      customBodyRender: (value, tableMeta, updateValue) => {
        return <Typography>{value.carrera.nombre}</Typography>;
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <BotonComponent
                click={() => {
                  const data = matriculasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setActivoMatriculasAction(dispatch, data);
                  history.push(ROUTES.panelMatriculas.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel del torneo"
              />
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = matriculasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoMatriculasAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  const data = matriculasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  window.open(data.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },

    rowsPerPage: 100,
    rowsPerPageOptions: [100, 150, 200],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: false,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={matriculasStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {matriculasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            Matrícula: {matriculasStore.activo.nroRegistro}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoMatriculas;
